import { Button, Flex, Spinner, Text } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import type { Font, FontsResponse } from "models/types/agency-settings";
import { fontModel } from "modules/agency-settings/models/font-model";
import { UploadedFontCard } from "modules/agency-settings/screens/branding/components/uploaded-font-card";

type UploadedFontsTabProps = {
  setIsUploadFontModalOpen: (isOpen: boolean) => void;
};

export function UploadedFontsTab({
  setIsUploadFontModalOpen,
}: UploadedFontsTabProps) {
  const { data: uploadedFontsData, isLoading: isLoadingFonts } =
    useQuery<FontsResponse>(fontModel.queries.list());

  const hasUploadedFonts =
    uploadedFontsData?.data && uploadedFontsData.data.length > 0;

  return (
    <Flex direction={"column"} gap={6} mt={2}>
      <Flex direction={"row"} justify={"space-between"} align={"center"}>
        <Text fontSize={"md"} color={"gray.600"}>
          Once uploaded, custom fonts are available for selection in the
          &quot;Text styles&quot; tab
        </Text>

        {hasUploadedFonts && (
          <Button
            colorScheme={"gray"}
            onClick={() => setIsUploadFontModalOpen(true)}
          >
            Upload font
          </Button>
        )}
      </Flex>

      {isLoadingFonts ? (
        <Flex justify={"center"} py={8}>
          <Spinner />
        </Flex>
      ) : hasUploadedFonts ? (
        <Flex direction={"column"} gap={3}>
          {uploadedFontsData.data.map((font: Font) => (
            <UploadedFontCard key={font.id} font={font} />
          ))}
        </Flex>
      ) : (
        <Flex
          p={8}
          borderWidth={"1px"}
          borderRadius={"md"}
          borderStyle={"dashed"}
          justify={"center"}
          align={"center"}
          direction={"column"}
          gap={4}
        >
          <Text color={"gray.500"}>No custom fonts uploaded yet</Text>
          <Button
            size={"sm"}
            colorScheme={"gray"}
            onClick={() => setIsUploadFontModalOpen(true)}
          >
            Upload font
          </Button>
        </Flex>
      )}
    </Flex>
  );
}
